import { RemoteTrack, RemoteAudioTrack, RemoteVideoTrack, RemoteTrackPublication } from "twilio-video";

export const isMediaTrack = (track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack =>{
  return track.kind === 'audio' || track.kind === 'video';
};

export const findTrackByKind = (tracks: Map<string, RemoteTrackPublication>, kind: string) => {
  let result: RemoteTrackPublication | undefined;

  tracks.forEach((track) => {
    if (track.kind === kind) {
      result = track;
      return;
    }
  });

  return result;
};

export const isParticipantMediaEnabled = (tracks: Map<string, RemoteTrackPublication>, kind: string) => {
  const track = findTrackByKind(tracks, kind);

  if (!track) {
    return false;
  }

  return track.isTrackEnabled;
};
